import { createAction, props } from '@ngrx/store';
import { Link } from '../models/link';

export const loadLinks = createAction('[LinksStore] Load Links');

export const loadLinksSuccess = createAction(
    '[LinksStore] Load Links Success',
    props<{ data: Link[] }>()
);
